/* LJDA Cart Drawer — Client Enhancements */
(function () {
  'use strict';

  let lastFetchedProductId = null;

  /* ── Cross-sell ───────────────────────────────────── */
  /* El grid llega pre-renderizado desde Liquid con complementarios curados.
     Aqui solo intentamos mejorarlo con intent=complementary (Search & Discovery).
     NUNCA se cae a 'related': eso devolvia productos similares, no cross-sell. */
  function initCrossSell() {
    const el = document.querySelector('.ljda-cross-sell[data-product-id]');
    if (!el) return;

    const productId = el.dataset.productId;
    const grid = el.querySelector('.ljda-cross-sell__grid');
    if (!grid || !productId) return;

    if (!grid.dataset.ljdaBound) {
      grid.addEventListener('click', handleCrossSellAdd);
      grid.dataset.ljdaBound = '1';
    }
    initCrossSellNav(el);

    if (productId === lastFetchedProductId) return;

    fetchRecommendations(productId, 'complementary')
      .then(products => {
        if (!products || products.length === 0) return; // conserva el fallback de Liquid
        lastFetchedProductId = productId;
        renderCards(grid, products.slice(0, 6));
        initCrossSellNav(el);
      })
      .catch(() => {});
  }

  function initCrossSellNav(el) {
    const grid = el.querySelector('.ljda-cross-sell__grid');
    const prevBtn = el.querySelector('.ljda-cross-sell__nav-btn--prev');
    const nextBtn = el.querySelector('.ljda-cross-sell__nav-btn--next');
    if (!grid || !prevBtn || !nextBtn) return;

    // Clone to remove any prior event listeners
    const newPrev = prevBtn.cloneNode(true);
    const newNext = nextBtn.cloneNode(true);
    prevBtn.parentNode.replaceChild(newPrev, prevBtn);
    nextBtn.parentNode.replaceChild(newNext, nextBtn);

    const cardWidth = () => {
      const card = grid.querySelector('.ljda-cross-sell__card');
      return card ? card.offsetWidth + 10 : grid.clientWidth * 0.55;
    };

    newPrev.addEventListener('click', () => grid.scrollBy({ left: -cardWidth(), behavior: 'smooth' }));
    newNext.addEventListener('click', () => grid.scrollBy({ left: cardWidth(), behavior: 'smooth' }));

    const updateBtns = () => {
      newPrev.disabled = grid.scrollLeft <= 0;
      newNext.disabled = grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 2;
    };

    grid.addEventListener('scroll', updateBtns, { passive: true });
    updateBtns();
  }

  function fetchRecommendations(productId, intent) {
    return fetch(`/recommendations/products.json?product_id=${productId}&limit=6&intent=${intent}`)
      .then(r => r.json())
      .then(data => data.products || []);
  }

  function renderCards(grid, products) {
    grid.innerHTML = products.map(p => {
      const imgSrc = (p.images && p.images[0] && p.images[0].src)
        || (typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image && p.featured_image.src) || '')
        || '';
      const variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
      const price = formatMoney(p.variants && p.variants[0] ? p.variants[0].price : 0);
      const url = escHtml(p.url || '#');
      return [
        `<div class="ljda-cross-sell__card" data-variant-id="${variantId}">`,
        `  <a class="ljda-cross-sell__card-link" href="${url}">`,
        imgSrc ? `    <img class="ljda-cross-sell__card-img" src="${imgSrc}" alt="${escHtml(p.title)}" loading="lazy" width="160" height="160">` : '',
        `    <p class="ljda-cross-sell__card-title">${escHtml(p.title)}</p>`,
        `  </a>`,
        `  <p class="ljda-cross-sell__card-price">${price}</p>`,
        `  <button class="ljda-cross-sell__card-btn" type="button"><span>+ Agregar</span></button>`,
        `</div>`,
      ].filter(Boolean).join('\n');
    }).join('');
  }

  function handleCrossSellAdd(e) {
    const btn = e.target.closest('.ljda-cross-sell__card-btn');
    if (!btn) return;
    const card = btn.closest('.ljda-cross-sell__card');
    const variantId = card && card.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.innerHTML = '<span>...</span>';

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .filter(el => el.dataset.sectionId)
      .map(el => el.dataset.sectionId)
      .join(',');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: sectionIds }),
    })
      .then(r => r.json())
      .then(cartAddResponse => {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cartAddResponse,
            data: {
              sections: cartAddResponse.sections || null,
              itemCount: 1,
              source: 'ljda-cross-sell',
            },
          },
        }));
        btn.innerHTML = '<span>✓ Agregado</span>';
        setTimeout(() => {
          btn.disabled = false;
          btn.innerHTML = '<span>+ Agregar</span>';
        }, 2000);
      })
      .catch(() => {
        btn.disabled = false;
        btn.innerHTML = '<span>+ Agregar</span>';
      });
  }

  /* ── Note debounce ───────────────────────────── */
  function initNoteField() {
    const field = document.querySelector('.ljda-note-field');
    if (!field) return;

    let timer;
    field.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ note: field.value }),
        });
      }, 600);
    });
  }

  /* ── Coupon redirect ────────────────────────── */
  function initCouponForm() {
    const form = document.querySelector('.ljda-coupon-form');
    if (!form) return;

    form.addEventListener('submit', e => {
      e.preventDefault();
      const input = form.querySelector('input');
      if (!input || !input.value.trim()) return;
      const code = encodeURIComponent(input.value.trim());
      window.location.href = `/checkout?discount=${code}`;
    });
  }

  /* ── Checkout btn — bypass history.back() race condition ── */
  function initCheckoutBtn() {
    const btn = document.querySelector('.ljda-checkout-btn');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const href = btn.getAttribute('href');
      if (!href) return;
      history.replaceState(null, '');
      window.location.href = href;
    });
  }

  /* ── Mobile swipe-to-close ─────────────────────── */
  function initSwipeClose() {
    if (window.innerWidth > 749) return;
    const dialog = document.querySelector('cart-drawer-component dialog');
    if (!dialog) return;

    let startY = 0;
    let deltaY = 0;

    dialog.addEventListener('touchstart', e => {
      startY = e.touches[0].clientY;
    }, { passive: true });

    dialog.addEventListener('touchmove', e => {
      deltaY = e.touches[0].clientY - startY;
    }, { passive: true });

    dialog.addEventListener('touchend', () => {
      if (deltaY > 120) {
        const closeBtn = dialog.querySelector('[ref="closeButton"]');
        if (closeBtn) closeBtn.click();
      }
      deltaY = 0;
    });
  }

  /* ── Watch for cart drawer open ────────────────── */
  function watchDrawerOpen() {
    const dialog = document.querySelector('cart-drawer-component dialog');
    if (!dialog) return;
    const obs = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'open' && dialog.hasAttribute('open')) {
          setTimeout(initCrossSell, 80);
          break;
        }
      }
    });
    obs.observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  /* ── Boot & re-init after cart morph ────────────────────── */
  function init() {
    initCrossSell();
    initNoteField();
    initCouponForm();
    initCheckoutBtn();
    initSwipeClose();
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();
    watchDrawerOpen();
  });
  document.addEventListener('cart:update', () => {
    setTimeout(init, 150);
    setTimeout(initCrossSell, 500);
  });

  /* ── Helpers ────────────────────────────────────── */
  function formatMoney(cents) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 0,
    }).format(Number(cents) / 100);
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
})();
